import React, { useEffect, useState, useContext } from 'react';
import api from '../api/client';
import { AuthContext } from '../context/AuthContext';
import './Payments.css';

const Payments = () => {
  const { access } = useContext(AuthContext);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const res = await api.get(`/api/payments/my/`);
        setPayments(res.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load payments');
        setLoading(false);
      }
    };
    fetchPayments();
  }, [access]);

  return (
    <div className="container">
      <div className="card">
        <h2 className="title">Payment History</h2>
        {loading ? (
          <p className="loading">Loading...</p>
        ) : error ? (
          <div className="error">{error}</div>
        ) : payments.length === 0 ? (
          <p className="noData">No payments found.</p>
        ) : (
          <table className="table">
            <thead>
              <tr className="tableHead">
                <th className="tableHeader">Date</th>
                <th className="tableHeader">Amount</th>
                <th className="tableHeader">Status</th>
                <th className="tableHeader">Deal</th>
                <th className="tableHeader">Reference</th>
              </tr>
            </thead>
            <tbody>
              {payments.map(p => (
                <tr key={p.id} className="tableRow">
                  <td className="tableCell">{new Date(p.created_at).toLocaleDateString('en-IN')}</td>
                  <td className="tableCell">₹{Number(p.amount).toLocaleString('en-IN')}</td>
                  <td className="tableCell">{p.status}{p.refund_utr && ` (refund UTR ${p.refund_utr})`}</td>
                  <td className="tableCell">{p.spv_name}</td>
                  <td className="tableCell">{p.gateway_payment_id || p.gateway_order_id}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Payments;
